import httpService from './core/http.service';

class OnboardingService {
    /** Runs a Gear Up sync now rather than waiting for the next quarter hour. */
    syncGearUp() {
        return httpService.post('/onboarding/gear-up/sync');
    }

    /**
     * Every Gear Up submission the poller has taken, newest first, with where each one got to.
     * One row per client submission — that is what an operator recognises, not a session id.
     */
    listGearUp(take = 100) {
        return httpService.get('/onboarding/gear-up', { take });
    }

    getGearUp(submissionId) {
        return httpService.get(`/onboarding/gear-up/${submissionId}`);
    }

    processGearUp(submissionId, body) {
        return httpService.post(`/onboarding/gear-up/${submissionId}/process`, body);
    }

    /** The Gear Up form's responses, read live from Typeform, newest first. */
    listTypeformResponses() {
        return httpService.get('/onboarding/gear-up/responses');
    }

    /** Brings one Gear Up response into a gear-up: its answers and lease file feed the next plan. */
    linkTypeformResponse(sessionId, responseId) {
        return httpService.post(`/onboarding/${sessionId}/typeform-response`, { responseId });
    }

    list(companyId, openOnly = true) {
        const params = { openOnly };
        if (companyId) params.companyId = companyId;
        return httpService.get('/onboarding', params);
    }

    get(id) {
        return httpService.get(`/onboarding/${id}`);
    }

    create(body) {
        return httpService.post('/onboarding', body);
    }

    updateSession(id, body) {
        return httpService.put(`/onboarding/${id}`, body);
    }

    close(id) {
        return httpService.post(`/onboarding/${id}/close`);
    }

    reopen(id) {
        return httpService.post(`/onboarding/${id}/reopen`);
    }

    generateRecap(companyId) {
        return httpService.get('/onboarding/recap', companyId ? { companyId } : {});
    }

    addFile(sessionId, file) {
        return httpService.postFile(`/onboarding/${sessionId}/files`, file);
    }

    updateFile(sessionId, fileId, body) {
        return httpService.put(`/onboarding/${sessionId}/files/${fileId}`, body);
    }

    deleteFile(sessionId, fileId) {
        return httpService.delete(`/onboarding/${sessionId}/files/${fileId}`);
    }

    extractFile(sessionId, fileId) {
        return httpService.post(`/onboarding/${sessionId}/files/${fileId}/extract`);
    }

    getPreview(sessionId) {
        return httpService.get(`/onboarding/${sessionId}/preview`);
    }

    getBuildPlan(sessionId) {
        return httpService.get(`/onboarding/${sessionId}/build-plan`);
    }

    listMessages(sessionId) {
        return httpService.get(`/onboarding/${sessionId}/messages`);
    }

    postMessage(sessionId, body) {
        return httpService.post(`/onboarding/${sessionId}/messages`, { body });
    }

    setQuestionClosed(sessionId, planId, question, closed) {
        return httpService.put(`/onboarding/${sessionId}/build-plan/${planId}/questions`, { question, closed });
    }

    setPlanBookie(sessionId, planId, name) {
        return httpService.put(`/onboarding/${sessionId}/build-plan/${planId}/bookie`, { name });
    }

    approveBuildPlan(sessionId, planId) {
        return httpService.post(`/onboarding/${sessionId}/build-plan/${planId}/approve`);
    }

    proposeFile(sessionId, fileId) {
        return httpService.post(`/onboarding/${sessionId}/files/${fileId}/propose`);
    }

    transformFile(sessionId, fileId) {
        return httpService.post(`/onboarding/${sessionId}/files/${fileId}/transform`);
    }
}

export default new OnboardingService();
